@if (lastVisitedAds.length !== 0) {
  <section class="my-5">
    <header class="mb-3 text-primary-emphasis">
      <h5 class="m-0 ps-2 border-start border-5 border-primary-subtle">Последно посетени</h5>
    </header>
    <ul class="list-unstyled row row-cols-2 row-cols-sm-3 row-cols-lg-3 row-cols-xl-6 justify-content-start g-4">
      @for (ad of lastVisitedAds; track ad.adId) {
        <li class="col">
          <nz-ad-card-mini [data]="ad"/>
        </li>
      }
    </ul>
  </section>
}
